import React from 'react';

type Direction = 'UP' | 'DOWN' | 'RIGHT' | 'LEFT';

interface ChevronProps {
  fill?: string;
  alt?: string;
  iconDirection?: Direction;
  sideSize?: number;
}

export const Chevron: React.FC<ChevronProps> = ({
  alt,
  fill = '#000000',
  iconDirection = 'RIGHT',
  sideSize = 15,
}) => {
  const rotate = (direction: Direction): string | undefined => {
    if (direction === 'RIGHT') return;
    if (direction === 'LEFT') return 'rotate(180)';
    if (direction === 'DOWN') return 'rotate(90)';
    return 'rotate(-90)';
  };

  return (
    <svg
      aria-labelledby='chevron-alt'
      width={sideSize}
      height={sideSize}
      viewBox='0 0 2048 2048'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      transform={rotate(iconDirection)}
    >
      {alt && <title id='chevron-alt'>{alt}</title>}
      <path
        d='M515 1955l930-931L515 93l90-90 1022 1021L605 2045l-90-90z'
      />
    </svg>
  );
};
